// The icon of a website, from the API (which gets it through the worker). Until it arrives, and for
// sites without one, the generic globe stays. The first request can come back empty while the worker
// is still looking for it, so it asks again a few times.
import { GlobeIcon } from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';

const RETRIES = 3;
const RETRY_MS = 3000;

export function SiteFavicon({ siteId }: { siteId: string }) {
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!failed || attempt >= RETRIES) return;
    const timer = setTimeout(() => {
      setAttempt(attempt + 1);
      setFailed(false);
    }, RETRY_MS);
    return () => clearTimeout(timer);
  }, [failed, attempt]);

  return (
    <>
      {!loaded && <GlobeIcon aria-hidden="true" />}
      {!failed && (
        <img
          src={`/api/app/sites/${siteId}/favicon${attempt > 0 ? `?intento=${attempt}` : ''}`}
          alt=""
          className={loaded ? 'size-5 object-contain' : 'hidden'}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      )}
    </>
  );
}
